import React, { useState, useEffect } from "react";
import { Donut } from "britecharts-react";
import CustomLegend from "../CustomLegend/CustomLegend";

const CustomDonut = (props:any) => {

    const { data, colors, width, height, externalRadius, internalRadius, legendLabel, isApiFailed} = props;
    const [donutData, setDonutData] = useState({data, width, height, colors, externalRadius, internalRadius, display: true});
    useEffect(() => {
        let propsData = { ...donutData, data: data, colors: colors, height: height};
        propsData = propsData.data.length ? {...propsData, display: false}: propsData;
        setDonutData(propsData);
    }, [props]);

    return (
        <>
            <Donut data={props.data} externalRadius={donutData.externalRadius} internalRadius={donutData.internalRadius} width={donutData.width}
                   height={donutData.height} highlightSliceById={1} colorSchema={donutData.colors}
                   hasFixedHighlightedSlice={true} shouldShowLoadingState={donutData.display}/>
            {legendLabel && <CustomLegend isApiFailed={isApiFailed} data={donutData.data} colors={donutData.colors} />}
        </>
    );
}

export default CustomDonut;
